import {
  Chart as ChartJS,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  LinearScale,
  CategoryScale,
} from "chart.js";
import { Line } from "react-chartjs-2";
import zoomPlugin from "chartjs-plugin-zoom";
import { DeviceConfiguration } from "models/devices/configuration";
import { externalTooltipHandler } from "./elements/tooltip";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  zoomPlugin
);

const LineChart = (props: {
  id?: string;
  data: any;
  config?: DeviceConfiguration;
  height?: number;
}) => {
  const { id, data, config, height } = props;

  const getUnitForAxis = (axisId: "y" | "y1") => {
    const firstDatasetForAxis = data.datasets.find(
      (ds: any) => ds.yAxisID === axisId
    );
    return firstDatasetForAxis?.unit || "";
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: "top" as const,
      },
      title: {
        display: false,
        text: "",
      },
      tooltip: {
        enabled: false,
        position: "nearest" as const,
        external: externalTooltipHandler,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        // max: 31,
        grid: {
          color: "transparent",
        },
        ticks: {
          font: {
            size: 14,
            weight: 600,
          },
        },
      },
      y: {
        weight: 10,
        border: {
          dash: [5, 5],
        },
        grid: {
          drawBorder: false,
          color: "#cccccc",
        },
        ticks: {
          font: {
            size: 14,
            weight: 600,
          },
          callback: function (value: number | string) {
            const num = typeof value === "number" ? value : parseFloat(value);
            return `${!isNaN(num) ? num.toFixed(2) : value} ${getUnitForAxis(
              "y"
            )}`;
          },
          // maxTicksLimit: 5,
        },
      },
      y1: {
        position: "right" as const,
        grid: {
          drawOnChartArea: false,
        },
        ticks: {
          font: {
            size: 14,
            weight: 600,
          },
          callback: function (value: number | string) {
            const num = typeof value === "number" ? value : parseFloat(value);
            return `${!isNaN(num) ? num.toFixed(2) : value} ${getUnitForAxis(
              "y1"
            )}`;
          },
          // maxTicksLimit: 5,
        },
      },
    },
    animation: {
      duration: 100,
    },
  };

  return (
    <div style={{ height: height - 180 }} className="w-full ">
      <Line id={id} options={options} data={data} className={`w-full`} />
    </div>
  );
};

export default LineChart;
